import { theme } from '@chakra-ui/core';

// import customIcons from './customIcons';
import zetaColors from './colors';

export const SMALL_SCREEN = '800px';
export const MEDIUM_SCREEN = '801px';
export const LARGE_SCREEN = '1080px';

const fonts = {
  body: "'Open Sans', sans-serif",
  heading: "'Open Sans', sans-serif",
  mono: "'Open Sans', sans-serif",
  restora: "'restorablack-1'"
};

const breakpoints = ['40em', '52em'];

const space = {
  px: '1px',
  '0': '0',
  '1': '0.25rem', // 4px
  '2': '0.5rem', // 8px
  '3': '0.75rem', // 12px
  '4': '1rem', // 16px
  '5': '1.25rem', // 20px
  '6': '1.5rem', // 24px
  '7': '1.75rem', // 28px
  '8': '2rem', // 32px
  '10': '2.5rem', // 40px
  '12': '3rem', // 48px
  '15': '3.75rem', // 60px
  '16': '4rem', // 64px
  '18': '4.5rem', // 72px
  '20': '5rem', // 80px
  '24': '6rem', // 96px
  '26': '7.5rem', // 120px
  '32': '8rem', // 128px
  '36': '8.75rem', // 140px
  '40': '10rem', // 160px
  '45': '11.5rem', // 184px
  '48': '12rem', // 192px
  '55': '13.75rem', // 220px
  '56': '14rem', // 224px
  '64': '16rem', // 256px
  '66': '18rem', // 288px
  '67': '19rem', // 304px
  '68': '20rem', // 320px
  '69': '22rem',
  '70': '31.25rem', // 500px
  '74': '33.125rem', // 530px
  '80': '40rem' // 640px
};

const sizes = {
  ...space,
  full: '100%',
  '3xs': '14rem', // 224px
  '2xs': '16rem', // 256px
  xs: '20rem', // 320px
  sm: '24rem', // 380px
  md: '28rem', // 448px
  lg: '35rem', // 560px
  xl: '37rem', // 592px
  '2xl': '42rem', // 672px
  '3xl': '46.25rem', // 768px
  '4xl': '56rem', // 896px
  '5xl': '64rem' // 1024px
};

export const colors = { ...zetaColors };

export default {
  ...theme,
  fonts,
  fontSizes: {
    heading: '32px',
    mobileHeading: '28px',
    title: '24px',
    mobileTitle: '18px',
    description: '18px',
    mobileDescription: '16px',
    xxs: '0.625rem', // 10px
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    md: '1rem', // 16px
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    '2xl': '1.5rem', // 24px
    '3xl': '1.75rem', // 28px
    '3.5xl': '1.875rem', //30px
    '4xl': '2rem', // 32px
    '5xl': '2.25rem', // 36px
    '5.5xl': '2.5rem', // 40px
    '6xl': '2.625rem', // 42px
    '7xl': '3rem', // 48px
    '8xl': '3.125rem', // 50px
    '8.5xl': '3.4375' // 55px
  },
  lineHeights: {
    normal: 'normal',
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: '2',
    '3': '.75rem', // 12px
    '3.5': '0.875rem', // 14px
    '4': '1rem', // 16px
    '5': '1.25rem', // 20px
    '6': '1.5rem', // 24px
    '7': '1.75rem', // 28px
    '8': '2rem', // 32px
    '9': '2.25rem', // 36px
    '10': '2.5rem', // 36px
    '11': '2.75rem' // 44px
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em'
  },
  space,
  breakpoints,
  sizes,
  colors: {
    ...theme.colors,
    ...zetaColors
  },
  icons: {
    ...theme.icons
    // ...customIcons,
  }
};
